// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3zDsg","footer":"ModalCreateQualiphyProcedure_footer__13FWF","additionData":"ModalCreateQualiphyProcedure_additionData__21fIk"};